import { useEffect, useState } from 'react';
import { ProjectStatus } from '../../../../domain/projectStatus/projectStatus';
import { Link, useNavigate } from 'react-router-dom';
import { CreateProjectState } from '../../../../domain/projectStatus/createProjectState';
import { ProjectStatusRepository } from '../../../../infrastructure/repositories/projectStatus/projectStatusRepository';
import { Private_Routes } from '../../../../main/constants';
import { UpdateProjectState } from '../../../../domain/projectStatus/updateProjectState';
import FormErrorMessage from '../../../shared/components/forms/FormErrorMessage';
import ProjectStatusInformationSection from './ProjectStatusInformationSection';

interface Props {
    isNewProjectStatus: boolean;
    projectStatus?: ProjectStatus | null;
}

export const ProjectStatusForm = ({
    isNewProjectStatus,
    projectStatus: selectedProjectStatus,
}: Props) => {
    const initialState = selectedProjectStatus ?? {
        id: 0,
        name: '',
        description: '',
        color: '',
    };

    const [projectStatus, setProjectStatus] = useState<ProjectStatus>(initialState);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isIncomplete, setIsIncomplete] = useState(true);

    const navigate = useNavigate();

    const handleInputChange = (
        name: string,
        value: string | boolean | number[] | number | undefined
    ) => {
        setProjectStatus({ ...projectStatus, [name]: value });
    };

    const handleError = (error: any) => {
        setErrorMessage(error.response.data);
        setIsSubmitting(false);
        window.scrollTo({ behavior: 'smooth', left: 0, top: 0 });
    };

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();

        setIsSubmitting(true);
        setErrorMessage('');

        if (isNewProjectStatus) {
            let body: CreateProjectState = {
                name: projectStatus.name,
                description: projectStatus.description,
                color: projectStatus.color,
            };

            ProjectStatusRepository.CreateProjectState(body)
                .then((response) => {
                    navigate(Private_Routes.PROJECT_STATUS_PAGE);
                    setIsSubmitting(false);
                })
                .catch(handleError);
        } else {
            let body: UpdateProjectState = {
                name: projectStatus.name,
                description: projectStatus.description,
                color: projectStatus.color,
            };

            ProjectStatusRepository.UpdateProjectState(body, projectStatus.id)
                .then((response) => {
                    navigate(Private_Routes.PROJECT_STATUS_PAGE);
                    setIsSubmitting(false);
                })
                .catch(handleError);
        }
    };

    useEffect(() => {
        if (projectStatus.name !== '' && projectStatus.description !== '') {
            setIsIncomplete(false);
        } else {
            setIsIncomplete(true);
        }
    }, [projectStatus]);

    return (
        <div>
            <FormErrorMessage errorMessage={errorMessage} />
            <div className='row'>
                <div className='col-xxl-12'>
                    <div className='card '>
                        <div className='card-body p-4'>
                            <div className='row'>
                                <ProjectStatusInformationSection
                                    projectStatus={projectStatus}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className='d-flex gap-2'>
                    <Link
                        to={Private_Routes.PROJECT_STATUS_PAGE}
                        className='btn btn-withe'
                    >
                        <i className='mdi mdi-arrow-left'></i> Atrás
                    </Link>

                    {isNewProjectStatus ? (
                        <button
                            className='btn btn-primary'
                            disabled={isSubmitting || isIncomplete}
                            onClick={handleSubmit}
                        >
                            {isSubmitting ? 'Creando...' : 'Crear'}
                        </button>
                    ) : (
                        <button
                            className='btn btn-primary'
                            disabled={isSubmitting || isIncomplete}
                            onClick={handleSubmit}
                        >
                            <i className='ri-arrow-up-circle-line'></i>
                            {isSubmitting ? 'Actualizando...' : 'Actualizar'}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};
